import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbDatepickerModule } from 'mdb-angular-ui-kit/datepicker';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { AsianboService } from 'src/app/services/asianbo.service';

@Component({
  selector: 'app-asiabo',
  standalone: true,
  imports: [
    MdbFormsModule, ReactiveFormsModule, MdbDatepickerModule,
    CommonModule, FormsModule
  ],
  templateUrl: './asiabo.component.html',
  styleUrl: './asiabo.component.scss'
})
export class AsiaboComponent {
  giorni = []
  listaOperazioni: any[] = []
  bSpinner = false
  data_selezionata : any
  translationOptions: any = {}

  constructor(private serv: AsianboService) {}

  ngOnInit(){
    this.translationOptions = this.serv.datepickerLangIT()
    let oggi = new Date().toISOString().split('T')[0]
    this.operazioniDelGiorno(oggi)
  }

  operazioniDelGiorno(giorno: string){
    this.bSpinner = true
    this.serv.operazioniDelGiorno(giorno).subscribe((res: any) => {
      console.log(res)
      if(res.res=='ok'){
        this.listaOperazioni = res.data
      }else{
        alert(res.msg)
      }
      this.bSpinner = false
    })
  }

  onDateChange(event: any){
    let dd = new Date(event) 
    dd.setDate(dd.getDate() + 1)   
    console.log(dd.toISOString().split('T')[0])
    this.listaOperazioni = []
    this.operazioniDelGiorno(dd.toISOString().split('T')[0])
  }

  getOperazioni(){
    console.log(this.data_selezionata)
    let dd = new Date(this.data_selezionata)  
    dd.setDate(dd.getDate() + 1)
    console.log(dd.toISOString().split('T')[0])
    this.listaOperazioni = []
    this.operazioniDelGiorno(dd.toISOString().split('T')[0])
  }
}
